import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {planPropTypes} from '../../../../utils/propTypes';

function DetailsSubscribe(props) {
  if (!props.isOpen) { return null; }

  function handlePlanSelection() {
    props.onPlanSelection(props.plan);
  }

  return <>
    <hr className="my-4"/>
    <div className="col-12 d-flex flex-column align-items-center mb-4">
      {props.showSubscribeButton &&
        <>
          <button
            type="button"
            className="large primary"
            onClick={handlePlanSelection}
          >
            <strong><Translate value="subscriptions.plans.subscribe"/></strong>
          </button>
        </>
      }
      <div className="information-primary font-size-xs mt-3">
        <span>
          <Translate value="subscriptions.plans.customerServiceMessage"/>
        </span>
      </div>
    </div>
  </>;
}

DetailsSubscribe.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  plan: planPropTypes().isRequired,
  showSubscribeButton: PropTypes.bool.isRequired,
  onPlanSelection: PropTypes.func.isRequired
};

export default DetailsSubscribe;
